import { StyledChartBox } from './chartBox.styles'

export const ChartBox = ({ children, ...props }) => {
  return (
    <StyledChartBox {...props}>
      {children}
    </StyledChartBox>
  )
}
